The information required for inferring a SEEK-specific location.
